<template>
  <el-table ref="table" class="au-table" :data="tableData" :height="height" :border="isEmpty" @cell-click="onCellClick">
    <el-table-column v-if="!isEmpty" label="序号" prop="index" :width="indexWidth" align="center">
      <template slot-scope="scope">
        {{ scope.$index + 1 }}
      </template>
    </el-table-column>
    <el-table-column v-for="item, index in columns" :key="index" :label="item.label" :prop="item.prop"
      :width="item.width" show-overflow-tooltip align="center">
      <template slot-scope="scope">
        <el-button v-if="item.copy && scope.row[item.prop]" type="text" icon="el-icon-copy-document"
          @click="handleCopy(scope.row[item.prop], $event)"></el-button>
        <slot :name="item.prop" :props="{ ...scope.row, $index: scope.$index }">
          <span>{{ scope.row[item.prop] }}</span>
        </slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * @description 表格
 * @created 2024/04/27 09:55:03
 * @property {Array} data 表格数据
 * @property {Array} columns 表格列配置
 * @property {Number} fixedHeight 表格固定高度
 */
// 工具
import copy from "@/utils/clipboard"
import { onScrollToLower } from "@/utils/scroll"
export default {
  name: "AuTable",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    fixedHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      page_index: 1
    }
  },
  computed: {
    isEmpty() {
      return this.tableData.length === 0 && this.columns.length === 0
    },
    height() {
      return window.innerHeight - this.fixedHeight
    },
    tableData() {
      // this.data 是全量数据，通过 onScrollToLower 方法进行分页，一次只渲染 size 条
      const size = parseInt(this.height / 30)
      return this.data.slice(0, this.page_index * size)
    },
    indexWidth() {
      if (this.columns.length === 0) return 0
      const length = String(this.data.length).length - 4
      return length > 0 ? 50 + length * 10 : 50
    }
  },
  watch: {
    data: {
      handler() {
        this.page_index = 1
      },
      deep: true
    }
  },
  mounted() {
    this.$refs.table.bodyWrapper.addEventListener("scroll", this.onScrollToLower)
  },
  beforeDestroy() {
    this.$refs.table.bodyWrapper.removeEventListener("scroll", this.onScrollToLower)
  },
  methods: {
    doLayout() {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    onScrollToLower({ target }) {
      onScrollToLower(target, () => {
        if (this.tableData.length < this.data.length) {
          this.page_index++
        }
      })
    },
    onCellClick(row, column, cell) {
      const obj = this.columns.find((item) => { return item.prop === column.property })
      if (obj && !obj.custom) {
        this.$refs.table.toggleRowSelection(row)
        const index = this.data.indexOf(row)
        this.$emit("cellClick", { row, index, column, cell })
      }
    },
    handleCopy(text, event) {
      copy(text, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.au-table {
  width: 100%;
}
</style>
